{
    "rssfeed adapter settings": {
        "en": "Adapter settings for rssfeed",
        "de": "Adaptereinstellungen für rssfeed",
        "ru": "Настройки адаптера для rssfeed",
        "pt": "Definições do adaptador para o rssfeed",
        "nl": "Instellingen voor de RSS-feed",
        "fr": "Paramètres de l'adaptateur pour le flux RSS",
        "it": "Impostazioni dell'adattatore per rssfeed",
        "es": "Configuración del adaptador para rssfeed",
        "pl": "Ustawienia adaptera dla kanału RSS",
        "uk": "Налаштування адаптера для rssfeed",
        "zh-cn": "Adapter settings for rssfeed"
    },
    "rss_oid": {
        "en": "RSS feed data point",
        "de": "RSS-Feed-Datenpunkt",
        "ru": "Элемент данных RSS-канала",
        "pt": "Dados do feed RSS",
        "nl": "RSS-feed-gegevenspunt",
        "fr": "Élément de données du flux RSS",
        "it": "Dato del feed RSS",
        "es": "Datos del canal RSS",
        "pl": "Element danych kanału RSS",
        "uk": "Елемент даних RSS-каналу",
        "zh-cn": "RSS feed data point"
    },
    "rss_template": {
        "en": "RSS Template",
        "de": "RSS-Vorlage",
        "ru": "Шаблон RSS",
        "pt": "Modelo RSS",
        "nl": "RSS-sjabloon",
        "fr": "Modèle RSS",
        "it": "Modello RSS",
        "es": "Plantilla RSS",
        "pl": "Szablon RSS",
        "uk": "Шаблон RSS",
        "zh-cn": "RSS Template"
    },
    "rss_maxarticles": {
        "en": "RSS max. articles",
        "de": "RSS – maximale Anzahl an Artikeln",
        "ru": "Максимальное количество статей в RSS",
        "pt": "Número máximo de artigos no RSS",
        "nl": "Max. aantal RSS-artikelen",
        "fr": "Nombre maximal d'articles RSS",
        "it": "Numero massimo di articoli RSS",
        "es": "Número máximo de artículos en RSS",
        "pl": "Maksymalna liczba artykułów w kanale RSS",
        "uk": "Максимальна кількість статей у RSS",
        "zh-cn": "RSS max. articles"
    },
    "rss_filter": {
        "en": "RSS Filter",
        "de": "RSS-Filter",
        "ru": "Фильтр RSS",
        "pt": "Filtro RSS",
        "nl": "RSS-filter",
        "fr": "Filtre RSS",
        "it": "Filtro RSS",
        "es": "Filtro RSS",
        "pl": "Filtr RSS",
        "uk": "Фільтр RSS",
        "zh-cn": "RSS Filter"
    },
    "rss_feedCount": {
        "en": "RSS Feed Number",
        "de": "Anzahl der RSS-Feeds",
        "ru": "Номер RSS-канала",
        "pt": "Número do feed RSS",
        "nl": "Aantal RSS-feeds",
        "fr": "Nombre d'abonnements RSS",
        "it": "Numero del feed RSS",
        "es": "Número de fuentes RSS",
        "pl": "Liczba kanałów RSS",
        "uk": "Номер RSS-каналу",
        "zh-cn": "RSS Feed Number"
    },
    "rss_dpCount": {
        "en": "Additional datapoint Count",
        "de": "Anzahl der zusätzlichen Datenpunkte",
        "ru": "Количество дополнительных точек данных",
        "pt": "Contagem de pontos de dados adicionais",
        "nl": "Aantal extra gegevenspunten",
        "fr": "Nombre de points de données supplémentaires",
        "it": "Numero di dati aggiuntivi",
        "es": "Recuento de datos adicionales",
        "pl": "Liczba dodatkowych punktów danych",
        "uk": "Кількість додаткових даних",
        "zh-cn": "Additional datapoint Count"
    },
    "rss_dp": {
        "en": "data point",
        "de": "Datenpunkt",
        "ru": "точка данных",
        "pt": "valor",
        "nl": "gegevenspunt",
        "fr": "data point",
        "it": "data point",
        "es": "dato",
        "pl": "punkt danych",
        "uk": "дані",
        "zh-cn": "data point"
    },
    "rss_name": {
        "en": "RSS Name",
        "de": "RSS-Name",
        "ru": "Название RSS",
        "pt": "Nome do RSS",
        "nl": "RSS-naam",
        "fr": "Nom du flux RSS",
        "it": "Nome RSS",
        "es": "Nombre del RSS",
        "pl": "Nazwa kanału RSS",
        "uk": "Назва RSS",
        "zh-cn": "RSS Name"
    },
    "group_feeds": {
        "en": "RSS Feed Group",
        "de": "RSS-Feed-Gruppe",
        "ru": "Группа RSS-каналов",
        "pt": "Grupo de feeds RSS",
        "nl": "RSS-feedgroep",
        "fr": "Groupe de flux RSS",
        "it": "Gruppo feed RSS",
        "es": "Grupo de fuentes RSS",
        "pl": "Grupa kanałów RSS",
        "uk": "Група RSS-каналів",
        "zh-cn": "RSS Feed Group"
    },
    "rss_prefix": {
        "en": "RSS Prefix",
        "de": "RSS-Präfix",
        "ru": "Префикс RSS",
        "pt": "Prefixo RSS",
        "nl": "RSS-voorvoegsel",
        "fr": "Préfixe RSS",
        "it": "Prefisso RSS",
        "es": "Prefijo RSS",
        "pl": "Prefiks RSS",
        "uk": "Префікс RSS",
        "zh-cn": "RSS Prefix"
    },
    "rss_article": {
        "en": "RSS Article count",
        "de": "Anzahl der RSS-Artikel",
        "ru": "Количество статей в RSS",
        "pt": "Número de artigos RSS",
        "nl": "Aantal RSS-artikelen",
        "fr": "Nombre d'articles RSS",
        "it": "Numero di articoli RSS",
        "es": "RSS: Número de artículos",
        "pl": "Liczba artykułów RSS",
        "uk": "Кількість статей у RSS",
        "zh-cn": "RSS Article count"
    },
    "rss_speed": {
        "en": "RSS Speed",
        "de": "RSS-Geschwindigkeit",
        "ru": "Скорость RSS",
        "pt": "Velocidade do RSS",
        "nl": "RSS-snelheid",
        "fr": "Vitesse RSS",
        "it": "Velocità RSS",
        "es": "Velocidad RSS",
        "pl": "Prędkość RSS",
        "uk": "Швидкість RSS",
        "zh-cn": "RSS Speed"
    },
    "rss_divider": {
        "en": "RSS Seperator",
        "de": "RSS-Trennzeichen",
        "ru": "Разделитель RSS",
        "pt": "Separador RSS",
        "nl": "RSS-scheidingsteken",
        "fr": "Séparateur RSS",
        "it": "Separatore RSS",
        "es": "Separador RSS",
        "pl": "Separator RSS",
        "uk": "Роздільник RSS",
        "zh-cn": "RSS Seperator"
    },
    "rss_pauseonhover": {
        "en": "RSS Pause on hover",
        "de": "RSS beim Bewegen des Mauszeigers anhalten",
        "ru": "RSS: при наведении курсора",
        "pt": "RSS: Pausar ao passar o cursor",
        "nl": "RSS: pauzeren bij aanwijzen",
        "fr": "RSS : mise en pause au survol",
        "it": "RSS: Pausa al passaggio del mouse",
        "es": "RSS: Pausa al pasar el cursor",
        "pl": "RSS – Wstrzymaj przy najechaniu kursorem",
        "uk": "RSS: Призупинити при наведенні курсору",
        "zh-cn": "RSS Pause on hover"
    },
    "rss_opentype": {
        "en": "RSS open type",
        "de": "RSS-Öffnungsart",
        "ru": "Способ открытия RSS",
        "pt": "Tipo de abertura RSS",
        "nl": "RSS-openingstype",
        "fr": "Type d'ouverture RSS",
        "it": "Tipo di apertura RSS",
        "es": "Tipo de apertura RSS",
        "pl": "Sposób otwierania RSS",
        "uk": "Спосіб відкриття RSS",
        "zh-cn": "RSS 打开方式"
    },
    "rss_link": {
        "en": "RSS Link",
        "de": "RSS-Link",
        "ru": "Ссылка RSS",
        "pt": "Link RSS",
        "nl": "RSS-link",
        "fr": "Lien RSS",
        "it": "Link RSS",
        "es": "Enlace RSS",
        "pl": "Link do kanału RSS",
        "uk": "Посилання на RSS",
        "zh-cn": "RSS Link"
    },
    "rss_withtime": {
        "en": "RSS with time",
        "de": "RSS mit Zeitangabe",
        "ru": "RSS с указанием времени",
        "pt": "RSS com hora",
        "nl": "RSS met tijdsaanduiding",
        "fr": "RSS avec l'heure",
        "it": "RSS con indicazione dell'ora",
        "es": "RSS con hora",
        "pl": "RSS z datą",
        "uk": "RSS із зазначенням часу",
        "zh-cn": "RSS with time"
    },
    "rss_withdate": {
        "en": "RSS with date",
        "de": "RSS mit Datum",
        "ru": "RSS с датой",
        "pt": "RSS com data",
        "nl": "RSS met datum",
        "fr": "RSS avec date",
        "it": "RSS con data",
        "es": "RSS con fecha",
        "pl": "RSS z datą",
        "uk": "RSS з датою",
        "zh-cn": "RSS 带日期"
    },
    "rss_withyear": {
        "en": "RSS with year",
        "de": "RSS mit Jahr",
        "ru": "RSS с годом",
        "pt": "RSS com ano",
        "nl": "RSS met jaar",
        "fr": "RSS avec année",
        "it": "RSS con anno",
        "es": "RSS con año",
        "pl": "RSS z rokiem",
        "uk": "RSS з роком",
        "zh-cn": "RSS 带年份"
    },
    "rss_withname": {
        "en": "RSS with name",
        "de": "RSS mit Name",
        "ru": "RSS с именем",
        "pt": "RSS com nome",
        "nl": "RSS met naam",
        "fr": "RSS avec nom",
        "it": "RSS con nome",
        "es": "RSS con nombre",
        "pl": "RSS z nazwą",
        "uk": "RSS з назвою",
        "zh-cn": "RSS 带名称"
    },
    "json_oid": {
        "en": "JSON data point",
        "de": "JSON-Datenpunkt",
        "ru": "Элемент данных JSON",
        "pt": "Ponto de dados JSON",
        "nl": "JSON-gegevenspunt",
        "fr": "Élément de données JSON",
        "it": "Voce di dati JSON",
        "es": "Punto de datos JSON",
        "pl": "Wartość danych JSON",
        "uk": "Елемент даних JSON",
        "zh-cn": "JSON data point"
    },
    "json_template": {
        "en": "JSON Template",
        "de": "JSON-Vorlage",
        "ru": "Шаблон JSON",
        "pt": "Modelo JSON",
        "nl": "JSON-sjabloon",
        "fr": "Modèle JSON",
        "it": "Modello JSON",
        "es": "Plantilla JSON",
        "pl": "Szablon JSON",
        "uk": "Шаблон JSON",
        "zh-cn": "JSON Template"
    }
}
